import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import {
  ExecuteOperationOnPipe,
  ModelWithForm,
  useValue,
  WhenModel,
  WhenModelValue,
} from '@morningtrain/react-resources'
import SmartviewContentSection from 'widgets/smartviews/partials/SmartviewContentSection'
import * as Displays from 'support/displays'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import { VacationRequestEditFields } from 'widgets/smartviews/vacation-requests/VacationRequestEditForm'
import VacationRequestSaveButton from 'widgets/smartviews/vacation-requests/VacationRequestSaveButton'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import DeleteModelOnClick from '../../../support/actions/generic/DeleteModelOnClick'
import * as UI from 'ui'
import { RequestFromTo } from 'widgets/smartviews/vacation-requests/RequestFromTo'

export default function CreateOrUpdateVacationRequestSmartview ({ create = false }) {
  const id = useValue('id')

  return (
    <Smartview header={<Translation name="smartviews.vacation_request.title"/>}>
      <ModelWithForm
        resourceName="vacation.vacation_requests"
        formOperationName="request"
        preventParentOperationRefresh={create}
        id={id}
        clean
      >
        {create && <MountSmartviewOnPipe
          smartview={<CreateOrUpdateVacationRequestSmartview create/>}
          replace/>}
        <Translator namespace="smartviews.vacation_request">
          <SmartviewContentSection>

            <WhenModel>
              <WhenModelValue name="status" condition="pending">
                <VacationRequestEditFields/>
              </WhenModelValue>
              <WhenModelValue name="status" condition="pending" negate>
                <SmartviewContentSection>
                  <SmartviewTextGroup>
                    <SmartviewText>
                      <div className="space-y-2">
                        <div className="flex justify-between">
                          <span><Translation name="type"/></span>
                          <Displays.Enum enum="vacation_request_type"
                                         name="type"/>
                        </div>
                        <div className="flex justify-between">
                          <span><Translation name="status"/></span>
                          <Displays.Enum enum="request_status" name="status"/>
                        </div>
                        <RequestFromTo/>
                        <WhenModelValue name="note">
                          <div className="flex justify-between">
                            <span><Translation name="note"/></span>
                            <Displays.Text name="note"/>
                          </div>
                        </WhenModelValue>
                      </div>
                    </SmartviewText>
                  </SmartviewTextGroup>
                </SmartviewContentSection>
              </WhenModelValue>
            </WhenModel>
            <WhenModel exists={false}>
              <VacationRequestEditFields/>
            </WhenModel>
          </SmartviewContentSection>

        </Translator>
        <WhenModel exists={false}>
          <SmartviewContentSeparator/>
          <VacationRequestSaveButton/>
        </WhenModel>
        <WhenModel>
          <WhenModelValue name="status" condition="declined" negate>
            <SmartviewContentSeparator/>
            <div className="flex justify-end items-center">
              <UI.ButtonWrap className="mr-4">
                <DeleteModelOnClick modelKey="period" pipes={
                  <>
                    <ExecuteOperationOnPipe operationName="my_requests"/>
                    <MountSmartviewOnPipe
                      smartview={<CreateOrUpdateVacationRequestSmartview/>}/>
                  </>
                }>
                  <UI.Button color="red">
                    <Translation name="generic.actions.delete"/>
                  </UI.Button>
                </DeleteModelOnClick>
              </UI.ButtonWrap>
              <VacationRequestSaveButton/>
            </div>
          </WhenModelValue>
        </WhenModel>

      </ModelWithForm>
    </Smartview>
  )
}
